import { Stack, useLocalSearchParams } from 'expo-router';

import { EarlyAccessScreen } from '@/components/early-access/early-access-screen';

export default function EarlyAccessRoute() {
  const { token } = useLocalSearchParams<{ token?: string | string[] }>();
  const inviteToken = Array.isArray(token) ? token[0] : token;

  return (
    <>
      <Stack.Screen options={{ title: 'Early access | 6am BKK' }} />
      <EarlyAccessScreen inviteToken={inviteToken} />
    </>
  );
}
